const TASK = 'task'
const WORKFLOW = 'workflow'
const WEBSERVICE = 'webservice'
const END = 'end'
const EMAIL = 'email'
const AVAILABLE_TASK_TYPES = [TASK, WORKFLOW, WEBSERVICE, END, EMAIL]

module.exports = {
  TASK,
  WORKFLOW,
  WEBSERVICE,
  END,
  EMAIL,
  AVAILABLE_TASK_TYPES
}
